import { CoreLibService } from 'core-lib';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuardService  {

  constructor(private router: Router, private coreLibService: CoreLibService) {
  }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

    return new Observable((observer) => {
      if (this.coreLibService.isAuthenticated()) {
        observer.next(true);
        observer.complete();
      } else {
        this.coreLibService.doAuth().toPromise().then(() => {
          observer.next(true);
          observer.complete();
        }).catch(() => {
          observer.next(false);
          observer.complete();
        });
      }
    });
  }

}
